<template>

  <div id="activityToast">
    <transition name="activity-toast" appear>
      <div v-if="showing" class="toast-wrapper">
        <div class="toast">
          <div class="message">{{ message }}</div>
          <v-btn v-if="route" block flat @click="open">VIEW</v-btn>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>

  export default {
    data () {
      return {
        duration: 5000,
        message: '',
        showing: false,
        timeout: false,
        route: false
      }
    },
    methods: {
      show (update, params) {
        
        // Required
        if (!update) {
          console.log('Activity Toast error');
          return
        }

        if (this.timeout) {
          this.dismiss();
          setTimeout(function () {
            this.show(update, params);
          }.bind(this), 800);
          return;
        }

        this.message = update.preview

        // Optional
        params = params || {}
        this.duration = params.duration ? params.duration : 5000;

        // Optional: Route
        if (update.route) {
          this.route = update.route;
        }
        else {
          this.route = false;
        }

        // Engage
        this.showing = true
        this.timeout = setTimeout(function () {
          this.dismiss();
        }.bind(this), this.duration);
      },

      dismiss () {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = false;
        this.showing = false;
      },

      open () {
        this.showing = false;
        if (this.route) {
          this.$router.push(this.route);
        }
      }
    },
    created () {
      window.ActivityToast = this;
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #activityToast {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;

    .toast-wrapper {

      position: absolute;
      top: 0;
      right: 0;
      max-width: 400px;
      box-sizing: border-box;
      margin: 16px;      

      .message {
        padding: 16px;
        background: #fffde8;
      }

      .toast {
        @include fontPrimary400();
        word-wrap: break-word;
        
        pointer-events: auto;
  
        overflow: hidden;
        cursor: pointer;
        background: $white;
        border-radius: 5px;
        color: $black87;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
      }

    }

    @media screen and (max-width: 550px) {
      
      .toast-wrapper {
        margin: 0;
        left: 0;
        max-width: 100%;

        .toast {
          border-radius: 0 0 5px 5px;          
        }
      }
    
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ActivityToast.vue